const translations = {
    fetchApplicatorError: 'Failed to retrieve applicators. Please try again later.'
};

export default translations;
